import { themed } from "../../../util/theme";
import { BaseButtonStyledProps } from "../types";
import { mapButtonAppearance } from "./mapButtonAppearance";

const fontWeightTheme = themed({
    primary: 700,
    secondary: 600,
    destructive: 700,
    "secondary-destructive": 600,
    share: 700,
    borderless: 600,
    link: {
        "lodestar-light": 400,
        "ursa-light": 500,
    },
    "primary-filled": 500,
    "primary-empty": 500,
    "secondary-filled": 500,
    "secondary-outlined": 500,
    "secondary-empty": 500,
    "canvas-filled": 500,
    "canvas-empty": 500,
    "destructive-filled": 500,
    "destructive-empty": 500,
});

export const getButtonFontWeight = ({ appearance, themeMode }: BaseButtonStyledProps): number => {
    return fontWeightTheme[mapButtonAppearance(appearance)](themeMode);
};

const fontSizeTheme = themed({
    large: {
        "lodestar-light": "14px",
        "ursa-light": "14px",
    },
    medium: {
        "lodestar-light": "13px",
        "ursa-light": "14px",
    },
    small: {
        "lodestar-light": "13px",
        "ursa-light": "14px",
    },
});

const lineHeightTheme = themed({
    "lodestar-light": "18px",
    "ursa-light": "16px",
});

export const getButtonFontSize = ({ size, themeMode }: BaseButtonStyledProps): string => {
    return fontSizeTheme[size](themeMode);
};

export const getButtonLineHeight = ({ themeMode }: BaseButtonStyledProps) => {
    return lineHeightTheme(themeMode);
};
